/**
 * @file site.config.ts
 * @path apps/website/src/config/site.config.ts
 * @description Centralized metadata, branding assets, and social profiles.
 */

/**
 * Metadata for SEO and branding.
 */
export const siteMetadata = {
  title: "Sir Bastians Shuttle Service",
  description:
    "Professional and reliable shuttle services in Cape Town. Cultural tours, airport transfers, and student transport.",
  url: "https://sirbastians.co.za",
  email: "info@sirbastians.co.za",
  phone: "27837001037",
};

/**
 * Branding assets (Logos and Favicons).
 * These paths sync with the Hero and Navigation components.
 */
export const branding = {
  title: "Sir Bastians",
  subtitle: "Shuttle Service",
  logoLight: "/assets/images/logo-light.png",
  logoDark: "/assets/images/logo-dark.png",
  favicon: "/favicon.ico",
  appleTouchIcon: "/assets/favicons/apple-touch-icon.png",
  ogImage: "/assets/images/og-image.png",
} as const;

/**
 * Valid labels for social media profiles.
 * ✨ FIXED: Adding 'WhatsApp' here resolves the TS error in FloatingActions.
 */
export type SocialLinkLabel =
  | "Facebook"
  | "Instagram"
  | "WeAreHomegrown"
  | "WhatsApp";

export interface SocialLink {
  href: string;
  label: SocialLinkLabel;
}

/**
 * External social media profiles.
 */
export const socialLinks: SocialLink[] = [
  {
    href: "https://www.facebook.com/SirBastiansShuttleService/",
    label: "Facebook",
  },
  {
    href: "https://www.instagram.com/sir_bastians_shuttle_service/?hl=en",
    label: "Instagram",
  },
  /*{
    href: "https://www.wearehomegrown.co.za/listing/sir-bastians-shuttle-service/",
    label: "WeAreHomegrown",
  },*/
  {
    href: "https://wa.me/27837001037",
    label: "WhatsApp",
  },
];

export const sectionSpacing = "px-4 md:px-16";
